// loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show() {
    console.log(this.loadingSubject)
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loading.service.ts